// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"markdown-themes-module--wrapper--20ucM"};